import React from 'react';
import { StatusPill, Rating, Tag } from '../brand/Primitives';

export default function DemoRestaurantCard({ r, onTap, featured }) {
  const size = featured ? { width: 330, height: 440 } : { width: '100%', minHeight: 280 };
  return (
    <div
      onClick={() => onTap && onTap(r)}
      style={{
        ...size,
        background: '#fff',
        borderRadius: 24,
        overflow: 'hidden',
        boxShadow: featured ? 'var(--cwm-shadow-hero)' : 'var(--cwm-shadow-card)',
        border: '1px solid rgba(255,255,255,0.9)',
        cursor: onTap ? 'pointer' : 'default',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 140ms ease-out',
      }}
      onMouseEnter={(e) => onTap && (e.currentTarget.style.transform = 'translateY(-3px)')}
      onMouseLeave={(e) => onTap && (e.currentTarget.style.transform = 'translateY(0)')}
    >
      <div
        style={{
          height: featured ? 200 : 150,
          background: r.hero,
          backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0) 50%, rgba(0,0,0,0.25) 100%), url(${r.photo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
        }}
      >
        <div style={{ position: 'absolute', top: 12, left: 12 }}>
          <StatusPill open={r.open}>{r.open ? 'Open' : 'Closed'}</StatusPill>
        </div>
        <div style={{ position: 'absolute', top: 12, right: 12 }}>
          <Rating value={r.rating} />
        </div>
      </div>
      <div style={{ padding: '14px 16px 16px', display: 'flex', flexDirection: 'column', gap: 8, flex: 1 }}>
        <div>
          <div style={{ fontWeight: 900, fontSize: featured ? 20 : 17, letterSpacing: '-0.01em', color: 'var(--cwm-ink)' }}>{r.name}</div>
          <div style={{ fontSize: 12, color: 'var(--cwm-gray-500)', fontWeight: 600, marginTop: 2 }}>
            {r.cuisine} · {r.price} · {r.distance}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {r.safe.slice(0, featured ? 3 : 2).map((t) => <Tag key={t.label} {...t} />)}
          {r.warn.slice(0, featured ? 2 : 1).map((t) => <Tag key={t.label} {...t} />)}
        </div>
        {featured && (
          <div style={{ fontSize: 13, color: 'var(--cwm-gray-700)', fontWeight: 500, lineHeight: 1.5, marginTop: 4 }}>
            {r.blurb}
          </div>
        )}
      </div>
    </div>
  );
}
